let countOccurenceInString = (str, ch) => {
  return (str.match(new RegExp(ch, "g")) || []).length;
};

export default countOccurenceInString;
